import React from "react";

const OrderSubmitted = ({ orderUid, restaurantName, pointsEarned, points }) => (
  <div>
    <div className="modal-bg" />
    <div className="modal notify-page">
      {/* Header */}
      <div className="head-general with-back">
        <a href="javascript: void(0)" />
        <h4>Order #{orderUid}</h4>
        <a href="/" className="close">
          <icon className="icon icon-close" />
        </a>
      </div>
      {/* Header */}
      <div className="modal-body">
        <div className="">
          <div className="white-bg head mt-10px">
            <icon className="icon icon-okay-2" />
            <h5>Order Submitted</h5>
            <p>
              Your order with <strong>{restaurantName}</strong> <br />
              has been placed.
            </p>
          </div>
          <div className="white-bg body mt-10px">
            <p>You will earn </p>
            <span>{pointsEarned}</span>
            <p>
              Your Total: {parseInt(points) + parseInt(pointsEarned)} eCoins
            </p>
          </div>
          <div className="buttons">
            <p>
              Thanks for helping support your local <br />
              independent restaurant community
            </p>
            <div>
              <a href={`/profile?orders#${orderUid}`} className="btn btn-gray2">
                Order Summary
              </a>
              <a href="/help" className="btn btn-gray">
                Help and Support
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default OrderSubmitted;
